export default "__VITE_ASSET__BFSvc5GY__"